<template>
  <div>
    <b-button v-if="hatchEnrichmentEnabled" variant="link" @click="openModal">
      <b-img
        center
        :src="require('@/assets/img/BitmapHetch.png')"
        width="24"
        height="24"
        alt="Hatch Enrichment"
      />
    </b-button>

    <HatchEnrichmentModal ref="hatchEnrichmentModal" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import HatchEnrichmentModal from "./hatch-enrichment-modal.vue";

export default {
  name: "HatchEnrichment",
  components: {
    HatchEnrichmentModal,
  },

  props: {
    did: {
      type: [String, Number],
      required: true,
    },
    cid: {
      type: [String, Number],
      required: true,
    },
  },

  computed: {
    ...mapState({
      hatchEnrichmentEnabled: (state) => state.account.hatchEnrichmentEnabled,
    }),
  },

  methods: {
    openModal() {
      this.$refs.hatchEnrichmentModal.open(this.did, this.cid);
    },
  },
};
</script>
